// extracted by mini-css-extract-plugin
module.exports = {"ListImageText":"styles_ListImageText__3DDgJ","content":"styles_content__2Aqrl","item":"styles_item__36yfx","itemImageWrapper":"styles_itemImageWrapper__p2Agc"};